import api from '../api/api-appdsv';

export const MaritalStatus = {
  Get: async () => await api.get('/estadoscivis'),
};
